import React from 'react'
import { Trans } from 'react-i18next'
import ReactSelect from 'react-select'
import ReactSelectCreatable from 'react-select/creatable'

const selectStyles = {
  control: (styles, state) => {
    return {
      ...styles,
      backgroundColor: 'white',
      borderRadius: 'var(--bs-border-radius)',
      color: 'var(--bs-body-color)',
      border: 'var(--bs-border-width) solid var(--bs-border-color)',
      ...(state.selectProps.valid === false && { borderColor: 'var(--danger)' }),
      minHeight: '2rem',
      ...(state.selectProps.isDisabled === true && { backgroundColor: 'white' }),
    }
  },

  menu: styles => ({ ...styles, zIndex: 1000 }),
  menuPortal: styles => ({ ...styles, zIndex: 1000 }),
  valueContainer: styles => ({ ...styles, paddingTop: '0.1rem', paddingBottom: '0.1rem' }),
  clearIndicator: styles => ({ ...styles, paddingTop: 0, paddingBottom: 0 }),
  dropdownIndicator: styles => ({ ...styles, paddingTop: 0, paddingBottom: 0 }),
}

const selectTheme = theme => {
  return {
    ...theme,
    borderRadius: 'var(--bs-border-radius)',
    colors: {
      ...theme.colors,
      primary25: '#86b7fe',
      primary: '#86b7fe',
    },
  }
}

const NativeSelect = ({ name, value, onChange, options, isDisabled = false, styles }) => {
  return (
    <select
      id={name}
      name={name}
      value={value?.value || ''}
      disabled={isDisabled}
      onChange={e => {
        const selectedOption = options.find(option => option.value === parseInt(e.target.value)) || null
        onChange(selectedOption, { name })
      }}
      styles={styles}
      className="form-control">
      <option key={null} value={''}>
        <Trans i18nKey="system_wide.styled_select.placeholder">Seleziona</Trans>
      </option>
      {options?.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

class StyledSelect extends React.Component {
  static defaultProps = {
    styles: selectStyles,
    theme: selectTheme,
    name: '',
    value: '',
    onChange: () => {},
    options: {},
    isMulti: false,
    allowCreate: false,
    disabled: false,
  }

  state = {
    is_mobile: window.innerWidth <= 768,
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ is_mobile: window.innerWidth <= 768 })
  }

  render() {
    let { styles, theme, name, value, onChange, options, isMulti, allowCreate, disabled, ...rest } = this.props
    const { is_mobile } = this.state
    let Select = allowCreate ? ReactSelectCreatable : is_mobile ? NativeSelect : ReactSelect
    return (
      <>
        <style jsx="true" global="true">{`
          .styled_select__control {
            background-color: #ffffff;
            color: var(--bs-body-color);
          }
          .styled_select__control--is-disabled {
            background-color: var(--bs-secondary-bg);
            color: var(--bs-body-color);
          }
          .styled_select__control--is-focused {
            border: solid 1px #86b7fe !important;
            box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
            background-color: white;
          }
          .styled_select__menu {
            max-height: 11rem;
            background-color: #f4f7fa;
          }
          .styled_select__menu > div {
            background-color: white !important;
          }
          .styled_select__single-value {
            color: var(--bs-body-color) !important;
          }
          .styled_select__option:hover {
            color: white !important;
          }
        `}</style>
        <Select
          // defaultMenuIsOpen
          classNamePrefix="styled_select"
          styles={styles}
          theme={theme}
          id={name}
          isMulti={isMulti}
          instanceId={name}
          name={name}
          value={value}
          onChange={onChange}
          options={options}
          isDisabled={disabled}
          {...(allowCreate === true && {
            formatCreateLabel: input => `'Create' "${input}"`,
          })}
          {...rest}
        />
      </>
    )
  }
}

export default StyledSelect
